export default {
    title: 'Search agent',
    createNew: 'New',
    tooltip: {
        title: 'Search agents',
        info: 'With the help of search agents you will receive regular updates on your search query. Select from the identified micro-trends which you want to add to the work space. You can choose an individual notification interval in the notification settings to be informed via e-mail about new micro-trends.'
    },
    alternative: {
        title: 'Looking for content?',
        text: 'Create the first search agent.',
        action: 'Create first search agent'
    },
    deprecated: 'The trend filter of this search agent contains a macro-trend that is no longer part of the current Trendone trend universe.'
}
